import {GraphqlMutation} from 'sopix/db/graphqlMutation'
import {ApiEndPoint} from 'sopix/db/apiEndPoint'

export class SimpleMutation extends GraphqlMutation{
    constructor(graphqlUrl, mutationName, response = []) {
        const apiEndPoint = new ApiEndPoint(graphqlUrl)
        super(apiEndPoint, mutationName, response)
    }
}